import React from 'react';
import { map, sum, get, isPresent, isNil, find } from 'lodash';
import Select from 'UI/Select';

export const TableHeaders = ({ headers, editable = false, updateSplaRecords, licenseTypes }) => map(headers, ({ Header, accessor }) => {
  if (editable) {
    const headerColumn = {
      Header,
      columns: [
        {
          Header: 'Quantity',
          id: `${accessor}_quantity`,
          accessor: data => get(data[accessor], 'quantity', 0),
          Cell: (data) => {
            let vmServiceBundleId = get(data, `original[${accessor}].vm_service_bundle_id`)
            let action = 'update'
            if (isNil(vmServiceBundleId)) {
              vmServiceBundleId = [data.original.vm_id, get(data, `original[${accessor}].service_bundle_id`)]
              action = 'create'
            }

            return (
              <input
                type="number"
                value={data.value}
                name={`${accessor}_quantity`}
                id={`${accessor}_quantity`}
                onChange={event => updateSplaRecords({
                  id: vmServiceBundleId,
                  field: 'quantity',
                  value: parseInt(event.target.value),
                  customerId: data.original.customer_id,
                  vmId: data.original.vm_id,
                  productKey: accessor,
                  action
                })}
              />
            )
          },
          Footer: ({ column, data }) => sum(map(data, column.id))
        },
      ]
    };

    if (isPresent(licenseTypes)) {
      headerColumn.columns = [...headerColumn.columns, {
        Header: 'License Type',
        id: `${accessor}_license_type`,
        minWidth: 200,
        accessor: (data) => get(data[accessor], 'license_type'),
        Cell: (data) => {
          let vmServiceBundleId = get(data, `original[${accessor}].vm_service_bundle_id`)
          let action = 'update'
          if (isNil(vmServiceBundleId)) {
            vmServiceBundleId = [data.original.vm_id, get(data, `original[${accessor}].service_bundle_id`)]
            action = 'create'
          }

          return (
            <Select
              value={find(licenseTypes, option => option.value === data.value)}
              options={licenseTypes}
              onChange={option => updateSplaRecords({
                id: vmServiceBundleId,
                field: 'license_type',
                value: option.value,
                customerId: data.original.customer_id,
                vmId: data.original.vm_id,
                productKey: accessor,
                action
              })} />
          )
        }
      }]
    }

    return (headerColumn);
  } else {
    return (
      {
        Header,
        id: accessor,
        accessor: (data) => get(data[accessor], 'quantity') || 0,
        Cell: ({ value }) => value === 0 ? <div style={{ color: "#989898" }}>{value}</div> : value,
        Footer: ({ column, data }) => sum(map(data, column.id))
      }
    );
  }
});
